module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-badge', {
    staticClass: "table-big",
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v("\n    Current time\n    "), _c('br'), _vm._v("\n    " + _vm._s(_vm.time) + "\n    "), _c('br'), _vm._v("\n    " + _vm._s(_vm.date) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1062a6e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CurrentTime.vue
// module id = 15
// module chunks = 0